export default class AssetsModel {
  public logo: string = null;
}
